import { useForm } from "react-hook-form";
import {
  FormError,
  InputHeader,
  Spacer,
  StyledInput,
} from "../../styles/CommonElements";
import styled from "styled-components";
import Button from "../Button";
import { formatEmailToLowercase } from "../../utils/emailUtils";

const CreateProfileForm = ({
  onSubmit,
  isSubmitting,
  /** Pre-filled email when the prior step already collected it (e.g. Free Gateway signup). */
  defaultEmail,
}) => {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { isValid, errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: defaultEmail ? { email: defaultEmail } : undefined,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputHeader htmlFor="firstName">First Name</InputHeader>
      <StyledStyledInput
        {...register("firstName", {
          required: "Please enter your first name",
        })}
        id="firstName"
        placeholder="Enter your first name"
        type="text"
      />
      {errors.firstName && <FormError>{errors.firstName.message}</FormError>}

      <Spacer $marginTop="1.5rem" />

      <InputHeader htmlFor="lastName">Last Name</InputHeader>
      <StyledStyledInput
        {...register("lastName", {
          required: "Please enter your last name",
        })}
        id="lastName"
        placeholder="Enter your last name"
        type="text"
      />
      {errors.lastName && <FormError>{errors.lastName.message}</FormError>}

      <Spacer $marginTop="1.5rem" />

      <InputHeader htmlFor="email">Email</InputHeader>
      <StyledStyledInput
        {...register("email", {
          required: "Please enter your email",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Please enter a valid email address",
          },
        })}
        id="email"
        placeholder="Enter your email"
        type="email"
        onChange={(e) => {
          const formattedEmail = formatEmailToLowercase(e.target.value);
          if (formattedEmail !== e.target.value) {
            setValue("email", formattedEmail);
          }
        }}
      />
      {errors.email && <FormError>{errors.email.message}</FormError>}

      <Spacer $marginTop="1.5rem" />

      <InputHeader htmlFor="phone">Phone Number</InputHeader>
      <StyledStyledInput
        {...register("phone", {
          required: "Please enter your phone number",
        })}
        id="phone"
        placeholder="Enter your phone number"
        type="tel"
      />
      {errors.phone && <FormError>{errors.phone.message}</FormError>}

      <Spacer $marginTop="3.5rem" />

      <Button
        type="submit"
        size="large"
        isLoading={isSubmitting}
        disabled={!isValid || isSubmitting}
      >
        Create Profile
      </Button>
    </form>
  );
};

const StyledStyledInput = styled(StyledInput)`
  background: white !important;
  border: 1px solid var(--color-gray-200) !important;
  border-radius: 8px !important;
`;

export default CreateProfileForm;
